module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"Actual amount with description":"Реальная сумма с описанием","Planned amount with description":"Планируемая сумма с описанием","placeholder":"5*250 яблоки \\r\\n(100 в скобках не учтётся)","planned":"запланировано"},"en":{"placeholder":"4*15 zoo tickets \\r\\n(100 in parentheses is ignored)"}}')
  delete Component.options._Ctor
}
